export const SUBMIT_BUTTON_TEXT = "Update Balance";
export const POST_SUBMIT_BUTTON_TEXT = "Balance Updated";

export const DEFAULT_QUANTITY = 0;
export const MIN_QUANTITY = 2;
export const MAX_QUANTITY = 100;

export const ICON_PRICE_IN_DOLLARS =
    window._nounConfig.singleIconPriceCents / 100;

export const INCOMPLETE_FORM_ERROR_MESSAGE =
    "Please enter your payment information.";
